import React from 'react';
import { Progress, Link } from '@backstage/core-components';
import { Tooltip } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { vulnerabilitySummary, securityScanComparator } from '../../lib/utils.esm.js';

const columns = [
  {
    title: "Tag",
    field: "name",
    type: "string",
    highlight: true
  },
  {
    title: "Last Modified",
    field: "last_modified",
    type: "date"
  },
  {
    title: "Security Scan",
    field: "securityScan",
    render: (rowData) => {
      if (!rowData.securityStatus && !rowData.securityDetails) {
        return /* @__PURE__ */ React.createElement("span", { "data-testid": "quay-repo-security-scan-progress" }, /* @__PURE__ */ React.createElement(Progress, null));
      }
      if (rowData.securityStatus === "queued") {
        return /* @__PURE__ */ React.createElement(Tooltip, { title: "The manifest for this tag is queued to be scanned for vulnerabilities" }, /* @__PURE__ */ React.createElement("span", { "data-testid": "quay-repo-queued-for-scan" }, "Queued"));
      }
      if (rowData.securityStatus === "unsupported") {
        return /* @__PURE__ */ React.createElement(Tooltip, { title: "The manifest for this tag has an operating system or package manager unsupported by Quay Security Scanner" }, /* @__PURE__ */ React.createElement("span", { "data-testid": "quay-repo-security-scan-unsupported" }, "Unsupported"));
      }
      const tagManifest = rowData.manifest_digest_raw;
      const retStr = vulnerabilitySummary(rowData.securityDetails);
      return /* @__PURE__ */ React.createElement(
        Link,
        {
          "data-testid": `${rowData.name}-security-scan`,
          to: `tag/${tagManifest}`
        },
        retStr
      );
    },
    id: "securityScan",
    customSort: (a, b) => securityScanComparator(a, b)
  },
  {
    title: "Size",
    field: "size",
    type: "numeric",
    customSort: (a, b) => a.rawSize - b.rawSize
  },
  {
    title: "Expires",
    field: "expiration",
    type: "date",
    emptyValue: /* @__PURE__ */ React.createElement("i", null, "Never")
  },
  {
    title: "Manifest",
    field: "manifest_digest",
    type: "string",
    customSort: (a, b) => a.manifest_digest_raw.localeCompare(b.manifest_digest_raw)
  }
];
const useStyles = makeStyles((theme) => ({
  empty: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center"
  }
}));

export { columns, useStyles };
//# sourceMappingURL=tableHeading.esm.js.map
